import FactoryApi from '../../api/factoryApi';
import toDictionaryHelper from "@/helper/toDictionaryHelper";

export default {
  state: {
    detail: {
      salutationId: 0
    },
    slaughters: [],
    factories: []
  },
  mutations: {
    FACTORY_FETCH(state, data) {
      state.detail = data;
    },
    FACTORY_FETCH_ALL(state, data) {
      state.factories = data;
    },
    FACTORY_SET_SLAUGHTERS(state, data) {
      state.slaughters = data;
    }
  },
  actions: {
    async FACTORY_ADD_OR_UPDATE_SUMMARY_ADDITION(_, {factoryId, form}) {
      try {
        await FactoryApi.addOrUpdateSummaryAddition(factoryId, form);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    FACTORY_CREATE(store, {factory}) {
      return new Promise((resolve, reject) => {
        FactoryApi.create(factory).then(response => {
          store.dispatch('NOTIFY_MSG', 'factory.notification.create');
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        })
      });
    },
    FACTORY_UPDATE(store, {factory}) {
      return new Promise((resolve, reject) => {
        FactoryApi.update(factory).then(response => {
          store.dispatch('NOTIFY_MSG', 'factory.notification.create');
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        })
      });

    },
    async FACTORY_FETCH(store, {id}) {
      return new Promise((resolve, reject) => {
        FactoryApi.fetch(id).then(response => {
          store.commit('FACTORY_FETCH', response.data);
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject();
        })
      });
    },
    async FACTORY_FETCH_ALL({commit}) {
      return new Promise((resolve, reject) => {
        FactoryApi.fetchAll().then(response => {
          commit('FACTORY_FETCH_ALL', toDictionaryHelper(response.data, 'id'))
          return resolve(response.data);
        }).catch(() => {
          return reject();
        })
      });
    },
    async FACTORY_FETCH_SLAUGHTERS(store) {
      try {
        const response = await FactoryApi.fetchSlaughters();
        store.commit('FACTORY_SET_SLAUGHTERS', response.data.items);
        return Promise.resolve(response.data.items);
      } catch (error) {
        store.dispatch('NOTIFY_ERROR', error);
        return Promise.reject();
      }
    },
    async FACTORY_FETCH_VETERINARIANS(store) {
      try {
        const response = await FactoryApi.fetchVeterinarians();
        return Promise.resolve(response.data.items);
      } catch (error) {
        store.dispatch('NOTIFY_ERROR', error);
        return await Promise.reject();
      }
    },
    async FACTORY_FETCH_SUMMARY_ADDITIONS(_, {factoryId}) {
      try {
        const response = await FactoryApi.fetchSummaryAdditions(factoryId);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async FACTORY_DELETE(store, {id}) {
      try {
        await FactoryApi.delete(id);
        return Promise.resolve();
      } catch (error) {
        store.dispatch('NOTIFY_ERROR', error);
        return Promise.reject();
      }
    },
    async FACTORY_SEARCH(store, {query}) {
      try {
        const result = await FactoryApi.search(query);
        return Promise.resolve(result.data);
      } catch (error) {
        store.dispatch('NOTIFY_ERROR', error);
        return Promise.reject();
      }
    }
  }

}
